import type { LeaveApplication } from "../types/leave-application.types";

export function leaveApplicationEmployeeLabel(row: LeaveApplication): string {
  const e = row.employee;
  if (!e) return `Employee #${row.employeeId}`;
  const fromUser = e.user
    ? [e.user.firstName, e.user.lastName].filter(Boolean).join(" ").trim()
    : "";
  const fromEmp = [e.firstName, e.lastName].filter(Boolean).join(" ").trim();
  const name = fromUser || fromEmp;
  if (name) {
    const code = e.code?.trim();
    return code ? `${name} (${code})` : name;
  }
  return e.code?.trim() || `Employee #${e.id}`;
}

export function leaveTypeLabel(row: LeaveApplication): string {
  return row.leaveType?.name?.trim() || `Leave type #${row.leaveTypeId}`;
}
